import { WORKOUT_SECTION_KEY } from '../..'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

export default function getWorkoutExercisesWorkoutSectionUtil (workoutSection) {
  return getValueReduxUtil(workoutSection,
    WORKOUT_SECTION_KEY.WORKOUT_EXERCISES
  ) || []
}
